// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__2ZIda","dense":"_type_dense__1BwCu","card":"_type_card__1fgPn","circle":"_type_circle__39DY7","action":"_type_action__2BPIB","icon":"_type_icon__1SeW9"};